module.exports = __webpack_public_path__ + "media/assets/images/logo-ec9644ffefadd7584b7fc375b59de40f.svg";